import * as React from 'react';
import 'bulma/css/bulma.css';

interface Props {
  callbackUrl: string;
}

const allowButton = (props: Props) => {
  return (
    <a
      className="button is-large is-link hvr-grow-shadow"
      href={props.callbackUrl}
    >
      <span className="icon is-medium">
        <i className="far fa-calendar-alt" />
      </span>
      <span>GET STARTED</span>
    </a>
  );
};

// const buttonMessage = 'Allow to Access Your Google Calendar';

export default allowButton;



// WEBPACK FOOTER //
// ./src/components/AllowButton.tsx